import Vue from 'vue'
//获取动态的config文件
let config;
if(sessionStorage.getItem("config")){
  config = JSON.parse(sessionStorage.getItem("config"))
}else{
  alert("未能加载配置文件")
}
export default {
  //服务端地址
  Url: config.Url,
  appID: 'wxbb16beb55ec5f415',
  // SystemName: '东南大学附属中大医院',
  SystemName: '',
  // SystemName: '',
  RoleLevel: [{
      value: 1,
      label: '个人'
    },
    {
      value: 2,
      label: '科室'
    },
    {
      value: 3,
      label: '单位'
    },
    {
      value: 4,
      label: '区域'
    },
    {
      value: 5,
      label: '管理员'
    }
  ],
  OrgType: [{
      value: 1,
      label: '单位'
    },
    {
      value: 2,
      label: '科室'
    }
  ],
  DictEnum: {
    // 医院
    hospital: 1,
    // 科室
    section: 2,
    // 用户类型
    usertype: 3,
    // 用户级别
    userlevel: 4,
    // 职称
    title: 5,
    // 专业
    specialty: 6,
    // 学历
    edu: 7,
    // 学位
    deg: 8,
    // 职务
    duty: 11,
    // 人才
    personnel: 12,
    // 岗位
    post: 13,
    // 支部
    branch: 15,
    // 届别
    stuyear: 16,
    // 住陪管理配置
    zpgl: 17,
    // 考核项目
    project: 18,
    // 考核时间
    examtime: 19
  },
  dateFormat(row, column) {
    var daterc = row[column.property]
    if (daterc != null) {
      var dateMat = new Date(daterc.replace('T', ' '))
      var year = dateMat.getFullYear()
      var month = dateMat.getMonth() + 1
      var day = dateMat.getDate()
      var hh = dateMat.getHours()
      var mm = dateMat.getMinutes()
      var ss = dateMat.getSeconds()
      var timeFormat = year + '-' + month + '-' + day + ' ' + hh + ':' + mm + ':' + ss
      return timeFormat
    }
  },
  Change(url, args, message, reflash) {
    let v = new Vue()
    v.$confirm(message, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      v.$http.post(url, args)
        .then(res => {
          console.log(res.data)
          if (res.data.Code === 0) {
            v.$message({
              message: '变更成功',
              type: 'success'
            })
            console.log('刷新页面')
            reflash()
            // v.$router.push(v.back)
          } else {
            v.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
        })
        .catch(err => {
          console.log(err)
          v.$message({
            message: '变更失败',
            type: 'error'
          })
        })
    }).catch(() => {})
  },
  Delete(url, args, name, reflash) {
    let v = new Vue()
    v.$confirm('删除 ' + name + ' 的信息, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      v.$http.post(url, args)
        .then(res => {
          console.log(res.data)
          if (res.data.Code === 0) {
            v.$message({
              message: '删除成功',
              type: 'success'
            })
            console.log('刷新页面')
            reflash()
            // v.$router.push(v.back)
          } else {
            v.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
        })
        .catch(err => {
          console.log(err)
          v.$message({
            message: '删除失败',
            type: 'error'
          })
        })
    }).catch(() => {})
  },
  // Http Post 请求
  HttpPost(url, args, FunSucess, FunFail, FunError, model) {
    let v = new Vue()
    v.$http.post(url, args)
      .then(res => {
        //console.log(res.data)
        if (res.data.Code === 0) {
          if (FunSucess != null) {
            FunSucess(res.data, model)
          } else {
            v.$message({
              message: '操作成功',
              type: 'success'
            })
          }
        } else {
          if (res.data.Code === 2) {
            v.$alert(res.data.Msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {
                console.log(action)
                window.location.href = v.$utils.Url.zpglurl + '/login.html'
              }
            })
          } else {
            if (FunFail != null) {
              FunFail(res.data, model)
            } else {
              v.$message({
                message: res.data.Msg + '，' + res.data.Data,
                type: 'error'
              })
            }
          }
        }
      })
      .catch(err => {
        console.log(err)
        if (FunError != null) {
          FunError()
        } else {
          v.$message({
            message: '操作失败',
            type: 'error'
          })
        }
      })
  },
  //地址栏传参
  UrlSearch: function() {
    var name, value;
    var str = location.href; //取得整个地址栏
    var num = str.indexOf("?")
    str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

    var arr = str.split("&"); //各个参数放到数组里
    for (var i = 0; i < arr.length; i++) {
      num = arr[i].indexOf("=");
      if (num > 0) {
        name = arr[i].substring(0, num);
        value = arr[i].substr(num + 1);
        this[name] = value;
      }
    }
  }
}
